<template>
  <div>
    <b-form @submit.prevent="save">
      <b-row>
        <b-col >
          <b-form-group :label="$t('RESPONSIBLE_PERSON')">
            <b-form-input type="text" v-model="contactData.responsible_person"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col >
          <b-form-group :label="$t('EMAIL')">
            <b-form-input type="email" v-model="contactData.email"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col >
          <b-form-group :label="$t('PHONE')">
            <b-form-input type="text" v-model="contactData.phone"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
        <b-form-group :label="$t('INSTITUTION')">
          <b-form-select v-model="contactData.institution.id">
            <option :value="null">-</option>
            <option :key="index" v-for="(institution, index) in institutions" :value="institution.id">
              {{institution.name}}
            </option>
          </b-form-select>
        </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <app-button-submit :c_permission="C_CONTACT_SAVE_BUTTON"></app-button-submit>
        </b-col>
        <b-col sm="6" md="6" lg="6">
          <delete-button v-if="contactData.id"
                         @click="showDeleteDialog=true"
                         :c_permission="C_CONTACT_DELETE_BUTTON"
                         class="pull-right">
          </delete-button>
        </b-col>
      </b-row>
    </b-form>
    <delete-dialog :show="showDeleteDialog"
                    @confirm="deleteCont"
                    @cancel="showDeleteDialog=false">
    </delete-dialog>
    <delete-dialog>
    </delete-dialog>
  </div>
</template>

<script>
import AppButtonSubmit from '@/components/app/AppSubmit'
import {createContact, updateContact, deleteContact} from '@/services/contact/index'
import {getInstitutionList} from "@/services/institution";
import DeleteDialog from '@/components/app/form/AppConfirmationDialog'
import DeleteButton from '@/components/app/AppDelete'
import {toast} from "@/shared/plugins/toastr"
import {getErrorMessage} from '@/mixins/error/getErrorMessage'
import {C_CONTACT_SAVE_BUTTON} from '@/shared/component_permission'
import {C_CONTACT_DELETE_BUTTON} from '@/shared/component_permission'
export default {
    props: {
      itemEdit:{}
    },
    data() {
        return {
            contactData: {
                id: null,
                responsible_person: null,
                email: null,
                phone: null,
                institution: {
                    id: null,
                    name: null
                }
            },
            institutions:[],
            contactEditAsidePanelState:false,
            showDeleteDialog:false,
            C_CONTACT_SAVE_BUTTON,
            C_CONTACT_DELETE_BUTTON
        }
    },
    components: {
        AppButtonSubmit,
        DeleteDialog,
        DeleteButton
    },
    methods: {
        getInstitutions() {
          getInstitutionList()
            .then(response => {
              this.institutions = response.data
            })
        },
        save() {
          let postData = {
            responsible_person: this.contactData.responsible_person,
            email: this.contactData.email,
            phone: this.contactData.phone,
            institution: this.contactData.institution.id
          }
            if(this.contactData.id) {
              this.update(postData)
            } else {
              this.create(postData)
            }
        },
        create(postData) {
            createContact(postData)
             .then(()=>{
                toast({
                'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
                'message': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                'type': 'success',
                'timeout': 2000,
             })
             this.$emit('closePanel', this.contactEditAsidePanelState);
             this.$emit('updated');
          },error=>{
            toast({
              title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
              message: this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
              'type': 'error',
              'timeout': 6000
            })
         })
      },
      update(postData) {
        updateContact(this.contactData.id, postData)
         .then(()=>{
              toast({
              'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
              'message': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
              'type': 'success',
              'timeout': 2000,
            })
            this.$emit('closePanel', this.contactEditAsidePanelState);
            this.$emit('updated');
          },error=>{
            toast({
              title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
              message: this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
              'type': 'error',
              'timeout': 6000
            })
        })
      },
       deleteCont(){
        deleteContact(this.contactData.id)
          .then(()=>{
            this.showDeleteDialog = false,
            toast({
              'title': this.$t('NOTIFICATIONS.DELETE_SUCCESS.MESSAGE'),
              'message': null,
              'type': 'success',
              'timeout': 2000,
            })
             setTimeout(() => {
                this.$emit('closePanel', this.contactEditAsidePanelState)
                this.$emit('updated')
            }, 500)
           },error=>{
            toast({
              'title': "Save  fail",
              'message': this.getMessages(error),
              'type': 'error',
              'timeout': 6000
            })
          })
      }
    },
    created() {
        this.getInstitutions()
        if(this.itemEdit) {
          this.contactData.id = this.itemEdit.id
          this.contactData.responsible_person = this.itemEdit.responsible_person,
          this.contactData.email = this.itemEdit.email,
          this.contactData.phone = this.itemEdit.phone,
          this.contactData.institution.id = this.itemEdit.institution.id
        }
    }
}
</script>
